export const button = {
  colorScheme: {
    light: {
      primary: {
        color: '{inverse.text.color}',
      },
      secondary: {
        color: '{text.color}',
      },

      // background: '#f59e0b',
      // borderColor: '#f59e0b',
      // hoverBackground: '#f59e0b',
      // hoverColor: '#ffffff',
      // hoverBorderColor: '#f59e0b',
    },
    dark: {
      // background: '#f59e0b',
      primary: {
        color: '{text.color}',
      },
      secondary: {
        color: '{text.color}',
      },
      // borderColor: '#f59e0b',
      // hoverBackground: '#f59e0b',
      // hoverColor: '#ffffff',
      // hoverBorderColor: '#f59e0b',
    },
  },
  extend: {
    accent: {
      color: '#f59e0b',
      inverseColor: '#ffffff',
      borderColor: '#f59e0b',
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
      .p-button-accent {
        background: ${dt('button.accent.color')};
        color: ${dt('button.accent.inverse.color')};
        transition-duration: ${dt('my.transition.fast')};
      }

      .p-button-text.p-button-secondary {
        color: ${dt('button.colorScheme.light.secondary.color')};
      }
      .p-button-text.p-button-secondary:not(:disabled):hover {
        color: ${dt('button.colorScheme.light.secondary.color')};
      }
    `,
};
